// assets/bb-aquecer-imagens.js
// Pré-aquecimento de imagens (Lote 8, e2e/imagens-carga.spec.ts). As seções com
// [data-aquecer-imagens] saem com as <img> em loading="lazy": o que está em slide ou aba escondida
// não baixa mais na carga. As marcadas com [data-aquecer] são o que aparece numa interação — o
// slide seguinte, os primeiros cartões de cada aba — e viram eager quando a seção chega a ~600 px
// da tela, para a troca não piscar. É o mesmo conjunto que a loja baixava na carga, só que depois.
//
// Um <script src> por seção, cada um executa este arquivo: a trava faz o observador nascer uma vez
// (com defer, a primeira execução já vê todas as seções da página).
(() => {
  if (window.bbAquecerImagens) return;
  window.bbAquecerImagens = true;

  const observador = new IntersectionObserver(
    (entradas) => {
      entradas.forEach((entrada) => {
        if (!entrada.isIntersecting) return;
        observador.unobserve(entrada.target);
        entrada.target.querySelectorAll('img[data-aquecer]').forEach((img) => {
          img.loading = 'eager';
        });
      });
    },
    { rootMargin: '600px 0px' }
  );

  document.querySelectorAll('[data-aquecer-imagens]').forEach((secao) => observador.observe(secao));
})();
